import AppDispatcher from '../AppDispatcher';

const QuoteFeedActions = {
  set: (items) => {
    AppDispatcher.dispatch({
      actionType: Constants.ActionTypes.QUOTE_FEED.SET,
      items: items
    });
  },
  update: () => {
    AppDispatcher.dispatch({
      actionType: Constants.ActionTypes.QUOTE_FEED.UPDATE
    });
  }
};

export default QuoteFeedActions;



// WEBPACK FOOTER //
// ./src/js/Actions/QuoteFeedActions.js